import {
  Component,
  ViewEncapsulation,
  ElementRef,
  ContentChildren,
  QueryList
} from '@angular/core';
import { MdlLayoutTabPanelComponent } from './mdl-layout-tab-panel.component';


export class MdlLayoutContentComponent {

   public tabs: QueryList<MdlLayoutTabPanelComponent>;

  public el: HTMLElement;

  constructor(private elRef: ElementRef) {
    this.el = elRef.nativeElement;
  }


static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mdl-layout-content',
  host: {
    '[class.mdl-layout__content]': 'true',
  },
  template:
    `<ng-content></ng-content>`,
  encapsulation: ViewEncapsulation.None,
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'tabs': [{ type: ContentChildren, args: [MdlLayoutTabPanelComponent, ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
